module.exports = __webpack_public_path__ + "img/Löschzug_Berufsfeuerwehr.78e7db3e.svg";